import { useState } from 'react';
import { CopyToClipboard, ExternalLink } from '@doist/icons/brand';
import { Button } from '@doist/marketist';
import { DraftModeBanner } from './draft-mode-banner';
type HelpCenterDraftModeBannerProps = {
  articleHref: string;
  articleId: number;
};
const copyLabel = 'Copy article path';
export function HelpCenterDraftModeBanner({
  articleId,
  articleHref
}: HelpCenterDraftModeBannerProps) {
  const [copyText, setCopyText] = useState(copyLabel);
  const articlePath = `${process.env.NEXT_PUBLIC_BASE_URL}${articleHref}`;
  const zendeskLink = `https://todoist.zendesk.com/knowledge/articles/${articleId}`;
  return <DraftModeBanner data-sentry-element="DraftModeBanner" data-sentry-component="HelpCenterDraftModeBanner" data-sentry-source-file="help-draft-mode-banner.tsx">
            <Button variant="tertiary" endIcon={ExternalLink} href={zendeskLink} size="small" target="_blank" rel="noopener" data-sentry-element="Button" data-sentry-source-file="help-draft-mode-banner.tsx">
                Edit on Zendesk
            </Button>

            <Button endIcon={CopyToClipboard} variant="tertiary" size="small" onClick={() => {
      navigator.clipboard.writeText(articlePath);
      setCopyText('Article path copied');
      setTimeout(() => setCopyText(copyLabel), 1_000);
    }} data-sentry-element="Button" data-sentry-source-file="help-draft-mode-banner.tsx">
                {copyText}
            </Button>
        </DraftModeBanner>;
}